<template>
  <div class="content-intro">
    <div class="detail-info" v-if="goodsInfo.goodsType != 'paper'">
      <div class="title"><img src="../../../assets/images/bookdetail/bookDetail.png" alt=""> 详细信息</div>
      <div class="book-info-intro" v-if="goodsInfo.goodsType == 'material'">
        <div class="book-intro1">
          <!-- <div>
            <span>开本：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.topicSize
                ? callDictionaries(acquireSourcelist2, goodsInfo.topicSize)
                : "-"
            }}</span>
          </div> -->
          <div>
            <span>版次：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.print
                ? callDictionaries(acquireSourcelist3, goodsInfo.print)
                : "-"
            }}</span>
          </div>
          <div>
            <span>字数：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.wordCount == null || goodsInfo.wordCount == ""
                ? "-"
                : goodsInfo.wordCount / 1000 + "千字"
            }}</span>
          </div>
          <div>
            <span>出版时间：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.publishDate == null || goodsInfo.publishDate == ""
                ? "-"
                : goodsInfo.publishDate
            }}</span>
          </div>
        </div>
        <!-- <div class="book-intro1">
          <div>
            <span>副书名：</span>
            <el-tooltip
              :content="goodsInfo.subTopicName"
              placement="top"
              v-ak-tooltip-auto-show
            >
              <span class="ellipsis-aRow">{{
                goodsInfo.subTopicName == null || goodsInfo.subTopicName == ""
                  ? "-"
                  : goodsInfo.subTopicName
              }}</span>
            </el-tooltip>
          </div>
          <div>
            <span>丛书名：</span>
            <el-tooltip
              :content="goodsInfo.seriesName"
              placement="top"
              v-ak-tooltip-auto-show
            >
              <span class="ellipsis-aRow">{{
                goodsInfo.seriesName == null || goodsInfo.seriesName == ""
                  ? "-"
                  : goodsInfo.seriesName
              }}</span>
            </el-tooltip>
          </div>
        </div> -->
        <div class="book-intro1" style="margin-bottom: 0px;">
          <div>
            <span>中图法分类：</span>
            <span class="ellipsis-aRow">
              <el-tooltip :content="goodsInfo.classification" placement="top">
                <span class="ellipsis-aRow"> {{ goodsInfo.classification ? goodsInfo.classification : "-" }}</span>
              </el-tooltip>
            </span>
          </div>
          <div>
            <span>自定义分类：</span>
            <el-tooltip :content="goodsInfo.selfName" placement="top">
              <span class="ellipsis-aRow"> {{ goodsInfo.selfName ? goodsInfo.selfName : "-" }}</span>
            </el-tooltip>
          </div>
          <div>
          </div>
        </div>
      </div>
      <div class="book-info-intro" v-if="
        goodsInfo.goodsType == 'reference' || goodsInfo.goodsType == 'other'
      ">
        <div class="book-intro2">
          <span>自定义分类：</span>
          <span class="ellipsis-twoRow">
            {{ goodsInfo.selfName ? goodsInfo.selfName : "-" }}
          </span>
        </div>
      </div>
      <div class="book-info-intro" v-if="goodsInfo.goodsType == 'looseleafOrtextbook'">
        <div class="book-intro2">
          <span>提供机构：</span>
          <span class="ellipsis-twoRow">
            {{ goodsInfo.instName ? goodsInfo.instName : "-" }}
          </span>
        </div>
      </div>
      <div class="book-info-intro" v-if="goodsInfo.goodsType == 'learning'">
        <div class="book-intro1">
          <div>
            <span>发行日期：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.issueTime ? goodsInfo.issueTime : "-"
            }}</span>
          </div>
          <div>
            <span>出版周期：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.publicationCycle
                ? callDictionaries(
                  acquireSourcelist3,
                  goodsInfo.publicationCycle
                )
                : "-"
            }}</span>
          </div>
          <div>
            <span>语种：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.language ? goodsInfo.language : "-"
            }}</span>
          </div>
        </div>
        <div class="book-intro1">
          <div>
            <span>主管单位：</span>
            <el-tooltip :content="goodsInfo.subTopicName" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.hostUnit ? goodsInfo.hostUnit : "-"
              }}</span>
            </el-tooltip>
          </div>
          <div>
            <span>主办单位：</span>
            <el-tooltip :content="goodsInfo.seriesName" placement="top" v-ak-tooltip-auto-show>
              <span class="ellipsis-aRow">{{
                goodsInfo.sponsor ? goodsInfo.sponsor : "-"
              }}</span>
            </el-tooltip>
          </div>
        </div>
        <div class="book-intro2">
          <span>中图法分类：</span>
          <span class="ellipsis-twoRow">
            {{ goodsInfo.classification ? goodsInfo.classification : "-" }}
          </span>
        </div>
        <div class="book-intro2">
          <span>自定义分类：</span>
          <span class="ellipsis-twoRow">
            {{ goodsInfo.selfName ? goodsInfo.selfName : "-" }}
          </span>
        </div>
      </div>
    </div>
    <div class="resource-file" v-if="goodsInfo.goodsType != 'paper' && goodsInfo.status != 3">
      <!-- <div class="title theme-title">资源文件</div>
      <div
        class="resource-item"
        v-for="(item, index) in sourceList"
        :key="index"
      >
        <div class="resource-name ellipsis-aRow" @click="toRead(index)">
          {{ item.sourceName ? item.sourceName : item.fileName }}
        </div>
        <div :class="item.sourceStatus == '0' ? 'active' : 'type'">
          {{ item.sourceStatus == 0 ? "付费" : "免费" }}
        </div>
      </div> -->
    </div>
    <div class="goods-detail">
      <div class="title"><img src="../../../assets/images/bookdetail/itemDetail.png" alt=""> 商品详情</div>
      <div class="detail ql-editor ql-snow" v-html="goodsInfo.introduction"></div>
      <noData v-if="goodsInfo.introduction == '' || goodsInfo.introduction == null"></noData>
    </div>
  </div>
</template>
<script>
import "quill/dist/quill.core.css"; // 引入样式
import "quill/dist/quill.snow.css"; // snow theme
import "quill/dist/quill.bubble.css"; // bubble theme
import noData from "@/components/noData.vue";
import { OuchnOss } from "@/plugins/OuchnOss";
import {
  TeachingClassList, //下拉树
  teachingAttrList //字典值
} from "@/api/bookstore/bookstore";
export default {
  data() {
    return {
      acquireSourcelist: [], //下拉书
      acquireSourcelist2: [], //开本
      acquireSourcelist3: [], //版次
      ouchnOss2: null
    };
  },
  props: {
    goodsInfo: Object,
    sourceList: Array,
    subjectId: String,
    goodsId: String,
    pthis: Object
  },
  components: {
    noData,
    audioread: () => import("@/views/onlineReading/components/audioread.vue")
  },
  created() {
    this.getresource_source();
    this.ouchnoss2 = new OuchnOss(true);
  },
  methods: {
    getresource_source() {
      //中图法分类
      TeachingClassList("law_type").then(res => {
        this.acquireSourcelist = res.data;
      });
      //开本
      teachingAttrList("oc_goods_format").then(res => {
        this.acquireSourcelist2 = res.data;
      });
      //版次
      teachingAttrList("oc_goods_edition").then(res => {
        this.acquireSourcelist3 = res.data;
      });
    },
    toRead(index) {
      // 如果该商品不是已下架就可以去阅读
      if (this.goodsInfo.status != 5) {
        //判断是从专题进入还是书城进入
        if (this.subjectId) {
          this.$router.push({
            path: "/onlineReading",
            query: {
              goodsId: this.goodsId,
              resourceType: "subject",
              resource: "bookCity",
              relevanceId: this.subjectId,
              readdefault: index
            }
          });
        } else {
          this.$router.push({
            path: "/onlineReading",
            query: {
              goodsId: this.goodsId,
              resourceType: "goods",
              resource: "bookCity",
              relevanceId: this.goodsId,
              readdefault: index
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.content-intro {
  box-sizing: border-box;
  // padding: 20px 0px;
  padding-top: 5px;

  .detail-info {


    .book-info-intro {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 14px;
      color: #626262;
      line-height: 19px;

      .book-intro1 {
        width: 100%;
        display: flex;
        align-items: center;
        // justify-content: space-between;
        margin-bottom: 8px;

        >div {
          display: flex;
          align-items: center;
          width: 33%;

          span:last-child {
            width: 130px;
          }
        }
      }

      .book-intro1:nth-of-type(2) {
        // width: 860px;
        width: 100%;
        justify-content: flex-start;

        >div {
          min-width: 33%;

          >span:last-child {
            // width: 230px;
            width: calc(100% - 100px);
          }
        }

        >div:last-child {
          margin-left: 66px;

          >span:last-child {
            // width: 250px;
            width: calc(100% - 100px);
          }
        }
      }

      .book-intro2 {
        width: 950px;
        display: flex;
        margin-bottom: 8px;

        >span:first-child {
          max-width: 100px;
          display: block;
        }

        >span:last-child {
          max-width: 850px;
        }
      }
    }
  }

  .resource-file {
    margin-bottom: 20px;

    .resource-item {
      text-decoration: none;
      box-sizing: border-box;
      padding-right: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 32px;
      background: #f2f2f2;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #666666;
      margin-bottom: 10px;

      .resource-name {
        max-width: 705px;
        box-sizing: border-box;
        padding-left: 6px;
        cursor: pointer;
      }

      .type {
        color: #2e9adb;
      }

      .active {
        color: #ff5353;
      }

      .type-zip {
        width: 48px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        background: #f2f2f2;
        border: 1px solid #2e9adb;
        border-radius: 6px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2e9adb;
        cursor: pointer;
      }
    }
  }

  .goods-detail {
    .detail {
      font-family: MiSans, MiSans;
      font-weight: 400;
      font-size: 13px;
      color: #3D3D3D;
      line-height: 24px;
      padding: 0;

      ::v-deep img {
        max-width: 100%;
      }
    }
  }

  // .title {
  //   font-size: 16px;
  //   margin-bottom: 25px;
  // }

  .title {
    display: flex;
    align-items: center;
    font-family: MiSans, MiSans;
    font-weight: 600;
    font-size: 15px;
    color: #191919;
    line-height: 20px;
    margin-bottom: 12px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
  }
}
</style>
